// extracted by mini-css-extract-plugin
module.exports = {"container":"InsurancePurchaseForm_container__33-IV","form":"InsurancePurchaseForm_form__3D5Df"};